import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconLinkComponent } from "./med-icon-link.component";

@NgModule({
  declarations: [
    MedIconLinkComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconLinkComponent,
  ],
})
export class MedIconLinkModule { }
